import React from "react";
import { Icon, Button } from "@tvg/design-system";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { Container } from "./styled-components";

interface Props {
  qaLabel?: string;
  loginAction: NullaryFn<void>;
  registerAction: NullaryFn<void>;
}

const LoginRegButton = ({
  qaLabel = "login-reg-buttons",
  loginAction,
  registerAction
}: Props) => (
  <Container data-qa-label={qaLabel}>
    <Button
      qaLabel="login-button"
      variant="secondary_dark"
      size="m"
      onPress={loginAction}
      padding="space-3"
      icon={
        <Icon
          name="lock"
          size="s"
          lineColor="white.900"
          backgroundColor="white.100"
          mr="space-1"
        />
      }
      iconPosition="start"
    >
      Log In
    </Button>
    <Button
      qaLabel="register-button"
      variant="primary"
      size="m"
      onPress={registerAction}
      padding="space-3"
      marginLeft="space-3"
      icon="userPlus"
      iconPosition="start"
    >
      Join Now
    </Button>
  </Container>
);

export default LoginRegButton;
